<template>
  <v-container>
    <v-row justify="space-between" no-gutters>
      <v-btn
        exact
        text
        :to="{
          name: 'OrderTemplateIndex'
        }"
      >
        <v-icon small left>fa-chevron-left</v-icon>Retour
      </v-btn>
      <v-row align="center" justify="end" no-gutters>
        <v-btn
          icon
          text
          v-if="template && id"
          v-show="!template.is_deleted"
          @click="copyTemplate"
        >
          <v-icon>fa-copy</v-icon>
        </v-btn>
        <v-btn
          icon
          text
          v-if="template && id"
          v-show="!template.is_deleted"
          @click="deleteTemplate"
        >
          <v-hover v-slot:default="{ hover }">
            <v-icon :color="hover ? 'error' : ''">fa-trash</v-icon>
          </v-hover>
        </v-btn>
        <v-btn
          icon
          text
          v-if="template && id"
          v-show="template.is_deleted"
          @click="restoreTemplate"
        >
          <v-hover v-slot:default="{ hover }">
            <v-icon :color="hover ? 'success' : ''">fa-trash-restore</v-icon>
          </v-hover>
        </v-btn>
      </v-row>
    </v-row>
    <v-card class="my-2">
      <v-card-text v-if="template" class="pb-0">
        <OrderTemplateFields
          v-bind.sync="template"
          :valid.sync="fieldsValid"
        ></OrderTemplateFields>
      </v-card-text>
      <v-card-text v-else>
        <v-skeleton-loader type="card-heading"></v-skeleton-loader>
      </v-card-text>
    </v-card>

    <v-card class="my-2">
      <v-card-text v-if="template">
        <OrderTemplateQuantityGrid
          ref="quantityGrid"
          :quantities="quantities"
          :sales_target="template.sales_target"
        ></OrderTemplateQuantityGrid>
      </v-card-text>
      <v-card-text v-else>
        <v-skeleton-loader
          type="table-heading, table-row-divider@4, table-tfoot"
        ></v-skeleton-loader>
      </v-card-text>
    </v-card>
    <v-row align="center" justify="end" no-gutters>
      <v-btn
        color="primary"
        @click="saveTemplate"
        :disabled="!fieldsValid"
        :block="$vuetify.breakpoint.xsOnly"
        :large="$vuetify.breakpoint.smAndDown"
      >
        <v-icon left small>fa-save</v-icon>Enregistrer
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
import { OrderTemplateFields, OrderTemplateQuantityGrid } from "../components";
export default {
  name: "OrderTemplateEditor",
  components: {
    OrderTemplateFields,
    OrderTemplateQuantityGrid
  },
  props: {
    id: {
      required: false,
      default: null
    }
  },
  async beforeRouteEnter(to, from, next) {
    next(async vm => {
      vm.getData();
    });
  },
  async beforeRouteUpdate() {
    this.getData();
  },
  computed: {
    ...mapGetters(["getStoreId", "getOrganisationId"])
  },
  data() {
    return {
      template: undefined,
      quantities: [],
      fieldsValid: false
    };
  },
  methods: {
    async getData() {
      try {
        this.$store.dispatch("slo");
        await this.$store.dispatch("loadSuppliers");
        if (this.id) {
          this.template = await api.retrieveOrderTemplate(this.id);
          this.quantities =
            this.template.quantities !== undefined
              ? this.template.quantities
              : [];
        } else {
          this.template = {
            name: "",
            is_deleted: false,
            store: this.getStoreId,
            supplier: null,
            organisation: this.getOrganisationId,
            sales_target: null,
            default_number_of_days: null
          };
          this.quantities = [];
        }
      } finally {
        this.$store.dispatch("elo");
      }
    },
    async saveTemplate() {
      try {
        this.$store.dispatch("slo");
        if (this.id) {
          await api.putOrderTemplate(this.id, this.template);
          await this.$refs.quantityGrid.saveQuantities(this.id);
        } else {
          const res = await api.postOrderTemplate(this.template);
          await this.$refs.quantityGrid.saveQuantities(res.id);
        }
        this.$router.push({ name: "OrderTemplateIndex" });
      } finally {
        this.$store.dispatch("elo");
      }
    },
    async deleteTemplate() {
      try {
        this.$store.dispatch("slo");
        if (this.id) {
          this.template.is_deleted = true;
          await api.putOrderTemplate(this.id, this.template);
        }
      } finally {
        this.$store.dispatch("elo");
      }
    },
    async restoreTemplate() {
      try {
        this.$store.dispatch("slo");
        if (this.id) {
          this.template.is_deleted = false;
          await api.putOrderTemplate(this.id, this.template);
        }
      } finally {
        this.$store.dispatch("elo");
      }
    },
    async copyTemplate() {
      try {
        this.$store.dispatch("slo");
        let res = await this.$dialog.prompt({
          text: "Id de la succursale",
          title: "Copie du gabarit vers une autre succursale"
        });
        if (this.id && res) {
          await api.copyOrderTemplate(this.id, Number(res));
        }
      } finally {
        this.$store.dispatch("elo");
      }
    }
  }
};
</script>

<style></style>
